import useScanBarcodeHook from "@/shared/hooks/useScanBarcodeHook";

const PosGlobalBarcode = () => {
  useScanBarcodeHook();
  return null;
};

export default PosGlobalBarcode;
